import { Column, OrderManagementConfig, SortType } from "../../objects/users/user";
import { OrderBy } from "ngx-odata-v4";
import { Component as ComponentEnum, Component } from "../../objects/components/component";
import { OrderViewType } from "../../objects/management/order/orderViewType";
import { Dictionary } from "lodash";

export class UserViewHelper {

    public static getColumnOrderBy(currentConfigDict: Dictionary<OrderManagementConfig>, component: Component): Column {
        let currentConfigs = currentConfigDict[component];

        let currentConfig = currentConfigs.ColumnsConfigs.find((x: any) => x.Type == currentConfigs.ViewType);
        let orderByColumn: Column;

        if (currentConfig)
            orderByColumn = currentConfig.Columns.find((c: any) => c.SortType != SortType.None);

        let orderBy: any;

        if (orderByColumn)
            orderBy = { PropertyName: orderByColumn.Property, OrderBy: orderByColumn.SortType == SortType.Asc ? OrderBy.Asc : OrderBy.Desc };

        return orderBy;
    }

    public static getColumns(userViewService: any, componentEnum: ComponentEnum, viewType: OrderViewType = null) {
        let currentViewType = viewType;

        if(currentViewType == null)
            currentViewType = this.getCurrentView(userViewService);

        if (userViewService.userView)
            return userViewService.userView[componentEnum].ColumnsConfigs
                .find( (x:any)=> x.Type == currentViewType)!.Columns
                .filter((x:any) => x.IsSelected == true)
                .sort((a: any, b: any) => {
                    return a.Index - b.Index
                });

        return [];
    }

    public static getCurrentView(userViewService: any) {
        if (userViewService.userView)
            return userViewService.userView[ComponentEnum.OrderManagement].ViewType;

        return OrderViewType.Tile;
    }
}


// WEBPACK FOOTER //
// ./app/common/helpers/userViewHelper.ts